// @flow

import qs from 'qs';
import Api from './ApiBase';

export const getParams = (params: any) => qs.stringify({
  include: 'job_alerts.categories,job_alerts.industries,job_alerts.regions,likes',
  ...params
});

class LikeApi extends Api {
  serializerType = 'likes';

  serializerOptions = {
    attributes: ['likeableId', 'likeableType', 'user'],
    user: { ref: 'id' }
  };

  create = async (like: {}) => {
    const body = await this.serialize(like);
    const json = await this.request('likes', { body: JSON.stringify(body), method: 'POST' });
    const data = await this.deserialize(json);

    return { data };
  }

  destroy = async (id: number | string) => {
    await this.request(`likes/${id}`, { method: 'DELETE' });
  }
}

export default new LikeApi();
